import React from "react";

export const DisclaimerAndPrivacy = () => {
  return (
    <section className="refund-policy">
      <div className="container">
        <header className="policy-header">
          <h1>Disclaimer & Privacy Policy</h1>
          <p className="policy-subtitle">
            Important legal notices regarding usage, liability, and data protection.
          </p>
        </header>

        <article className="policy-body">
          {/* Disclaimer */}
          <section className="policy-section">
            <h2>Disclaimer</h2>

            <p>
              OptionQuaant is a technical analysis indicator created strictly for educational and informational purposes. It is not intended to provide financial advice, investment advice, trading advice, or any recommendation to buy or sell financial instruments. All charts, signals, visual elements, support/resistance levels, breakout indications, and trend interpretations generated by OptionQuaant are based on mathematical calculations derived from historical price data and should be treated only as decision-support tools.
            </p>

            <p>
              Financial markets are highly volatile and unpredictable. Past performance is not an indicator of future results. The use of OptionQuaant does not guarantee profits, accuracy, or consistent performance. Signals may fail due to market conditions, sudden volatility, news events, low liquidity, slippage, execution delays, or other external factors beyond the scope of the indicator’s logic.
            </p>

            <p>
              Users acknowledge that all trading decisions are made at their own discretion and risk. The creators, developers, distributors, and affiliates of OptionQuaant shall not be held liable for any direct or indirect financial losses, damages, missed opportunities, or adverse outcomes resulting from the use or misuse of this indicator.
            </p>

            <p>
              OptionQuaant is not registered with any financial regulatory authority as an investment advisor, broker, or portfolio manager. The indicator does not consider individual financial circumstances, risk appetite, or trading objectives. Users are strongly advised to conduct their own analysis and consult with a qualified financial professional before making any trading or investment decisions.
            </p>

            <p>
              By accessing or using OptionQuaant, you agree that you understand the risks associated with trading and accept full responsibility for your actions. If you do not agree with this disclaimer, you should not use the indicator.
            </p>
          </section>

          <hr className="section-divider" />

          {/* Privacy Policy */}
          <section className="policy-section">
            <h2>Privacy Policy</h2>

            <p>
              Your privacy is important to us. This Privacy Policy explains how information is handled when you access or use OptionQuaant.
            </p>

            <p>
              OptionQuaant itself does not collect, store, or process personal financial data, trading account details, or brokerage information. The indicator operates entirely within the TradingView platform environment and relies only on chart data provided by TradingView.
            </p>

            <p>
              When you purchase or request access to OptionQuaant, you may be asked to provide basic information such as your name, email address, and TradingView username for the purpose of granting access to the indicator. This information is used solely for account verification, communication, support, and access management.
            </p>

            <p>
              We do not sell, rent, or share your personal information with third parties for marketing or commercial purposes. Your information is kept confidential and is only used to manage your access to OptionQuaant and provide necessary support.
            </p>

            <p>
              Please note that TradingView, payment processors, and communication platforms (such as email or messaging services) may collect and process data according to their own privacy policies. OptionQuaant is not responsible for the data practices of these third-party services.
            </p>

            <p>
              Reasonable measures are taken to protect user information from unauthorized access, misuse, or disclosure. However, no digital system is completely secure, and users acknowledge the inherent risks of sharing information online.
            </p>

            <p>
              By using OptionQuaant, you consent to this Privacy Policy. If you do not agree with the terms described, you should refrain from using the indicator.
            </p>

            <p>
              This policy may be updated from time to time to reflect changes in practices or legal requirements. Continued use of OptionQuaant after any updates constitutes acceptance of the revised Privacy Policy.
            </p>
          </section>
        </article>
      </div>
    </section>
  );
};